const SKIP_MAIN_ACCOUNT_CONFIRM_KEY = 'skipMainAccountPublishConfirm';

export const isMainAccountConfirmSkipped = () =>
  sessionStorage.getItem(SKIP_MAIN_ACCOUNT_CONFIRM_KEY) === 'true';

export const skipMainAccountConfirm = () =>
  sessionStorage.setItem(SKIP_MAIN_ACCOUNT_CONFIRM_KEY, 'true');
